export default __webpack_public_path__ + "static/media/settings-active.5780fa56.png";